import { ClassType } from '@lingoda/monolith-graphql';
import minBookingDateSelector from './minBookingDate';

export default minBookingDateSelector(ClassType.Individual);
